import formatDate from './formatDate';
import formatDay from './formatDay';
import daysFromIssuedDate from './daysFromIssuedDate';
import daysDistance from './daysDistance';
import formatCurrency from './formatCurrency';
import formatNumber from './formatNumber';
import truncate from './truncate';
import uppercase from './uppercase';

export default {
  daysDistance,
  daysFromIssuedDate,
  formatCurrency,
  formatDate,
  formatDay,
  uppercase,
  formatNumber,
  truncate,
};
